<template>
    <table class="table table-condensed">
        <thead>
        <tr>
            <th :class="(header.number_field) ? 'number' : ''" v-for="header in state.jsonResult.slot1.headers" :key="header.key">{{ header.header }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in state.jsonResult.slot1.data" :key="row.key">
            <td><router-link :to="`/tracker/${ row.tracker_id }`">{{ row.tracker_id }}</router-link></td>
            <td>{{ row.contact_name }}</td>
            <td class="number">${{ row.total_amount.toLocaleString() }}</td>
            <td>{{ row.contact_phone }}</td>
            <td>{{ row.contact_email }}</td>
            <td>{{ row.contact_email_cc }}</td>
            <td>{{ row.scheduled_ship }}</td>
            <td>{{ row.sch_receive_ship }}</td>

            <td>
                <input type="checkbox" :true-value="1" :false-value="0" :checked="row.call_ahead_complete" @click="toggleCallAhead($event, row.tracker_id)" />
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>

import { store } from "@/store/Report.store.js";

export default {
    name: "Results",
    data() {
        return {
            state: store.state
        };
    },
    methods: {
        toggleCallAhead: function(evt, tracker_id) {
            let value = (evt.target.checked) ? 1 : 0;
            store.customAPI('/tracker/save/' + tracker_id, {'params[call_ahead_complete]': value}).then(() => store.runReport('table', 'slot1'));
        }
    }
};

</script>